export const buildTime = '2026-10-13 12:36:58 UTC';
